import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath, isPlainObject } from "../../../../../utils";

export default function view() {
  const { $charge, $inputs } = this;
  let $this = this;

  return (view = ViewFactory({
    NAME: 'MOMO_FRANCO_INIT_VIEW',
    inputs: ['country', 'network', 'phone', 'authorization_code'],
    next() {
      const country = getValueAtPath($inputs, '[country].value');
      const network = getValueAtPath($inputs, '[network].value');
      const phonenumber = getValueAtPath($inputs, '[phone].value');
      const authorization_code = getValueAtPath($inputs, '[authorization_code].value');

      if (phonenumber && isPlainObject(country)) {
        let data =  {
          country: country.code,
          network: getValueAtPath(network, 'identifier') || null,
          phonenumber,
        };

        if (data['country'] === 'BF' && data['network'] !== 'mobicash') {
          data['authorization_code'] = authorization_code
        }

        if (data['country'] === 'SN' && data['network'] === 'Orangemoney') {
          data['use_qr'] = true;
        }

        if ( ['SN', 'CI'].includes(data['country']) && data['network'] === 'wave') {
          const redirectUrl = getValueAtPath($this.DATA, 'redirect_url');
          data['redirect_url'] = redirectUrl !== null ? redirectUrl : '#checkout:no_json_render';
        }
        
        $charge.init({
          data
        });
      }
    }
  }).call(this));
}
